import axiosInstance from '@/lib/axios';



export async function loginApi({ email, password }) {
    try {
        const formData = new FormData();
        formData.append('username', email); // ✅ match FastAPI expected field
        formData.append('password', password);

        const response = await axiosInstance.post('/auth/login', formData); // Axios handles baseURL internally

        const result = response.data;

        localStorage.removeItem('authToken');
        localStorage.removeItem('tokenType');
        localStorage.setItem('authToken', result.access_token);
        localStorage.setItem('tokenType', result.token_type);

        return result;


    } catch (err) {
        // Axios errors have a slightly different shape
        const message = err.response?.data?.detail || err.message || 'Login failed';
        throw new Error(message);
    }
}




export async function registerApi(formData) {

    // Step 1: Register user
    const registerResponse = await axiosInstance.post('/auth/register', formData);
    const { access_token, token_type } = registerResponse.data;

    // Save token
    localStorage.setItem('authToken', access_token);
    localStorage.setItem('tokenType', token_type);

    // Step 2: Set user preferences
    await axiosInstance.post(
        '/users/preferences',
        { sport: null },
        {
            headers: {
                Authorization: `${token_type} ${access_token}`,
            },
        }
    );


    return registerResponse.data;

}

